import React from "react";
import { Drawer, Box, Typography, IconButton, CircularProgress } from "@mui/material";
import { Close as CloseIcon, OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ProductConversion } from "../../services/productConversionService";
import { ConversionDetailContent } from "./ConversionDetailContent";

interface ConversionDetailDrawerProps {
    open: boolean;
    onClose: () => void;
    conversion: ProductConversion | null;
    loading?: boolean;
}

export const ConversionDetailDrawer: React.FC<ConversionDetailDrawerProps> = ({
    open,
    onClose,
    conversion,
    loading,
}) => {
    const navigate = useNavigate();

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: { xs: "100vw", sm: 480 }, p: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6">Conversion Details</Typography>
                    <Box>
                        {conversion && (
                            <IconButton
                                onClick={() =>
                                    navigate(`/inventory/conversions/${conversion.conversion_id}/view`)
                                }
                                title="Open full page"
                            >
                                <OpenInNewIcon />
                            </IconButton>
                        )}
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>

                {loading && (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                )}

                {!loading && conversion && (
                    <ConversionDetailContent conversion={conversion} />
                )}
            </Box>
        </Drawer>
    );
};
